// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let V4 = require("uuid/v4");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function getAttachmentStatuses(failed, inProgress, attachments) {
  return Stdlib_Array.filterMap(attachments, attachment => {
    let match = attachment.state;
    switch (match.TAG) {
      case "InProgress" :
        return Primitive_option.some(inProgress);
      case "Failed" :
        return Primitive_option.some(failed);
      case "NotStarted" :
      case "Success" :
        return;
    }
  });
}

function makeImageAttachment(id, key, fileName, contentType, previewUrl) {
  return {
    previewUrl: previewUrl,
    state: {
      TAG: "Success",
      _0: {
        id: id,
        key: key,
        fileName: fileName,
        contentType: contentType
      }
    }
  };
}

function makeFileAttachment(id, key, fileName, contentType) {
  return {
    previewUrl: undefined,
    state: {
      TAG: "Success",
      _0: {
        id: id,
        key: key,
        fileName: fileName,
        contentType: contentType
      }
    }
  };
}

function imagesReadyToSave(images) {
  return Stdlib_Array.filterMap(images, image => {
    let attachment = image.state;
    if (attachment.TAG === "Success") {
      return [
        image.previewUrl,
        attachment._0
      ];
    }
  });
}

function filesReadyToSave(files) {
  return Stdlib_Array.filterMap(files, file => {
    let attachment = file.state;
    if (attachment.TAG === "Success") {
      return attachment._0;
    }
  });
}

function makeLocalScope() {
  return "local:" + V4();
}

function useIdentity(serverDraftId, scopeKeyOpt) {
  let scopeKey = scopeKeyOpt !== undefined ? scopeKeyOpt : "";
  let scopeIdentity = React.useRef(serverDraftId !== undefined ? "server:" + serverDraftId + ":" + scopeKey : "local:" + V4());
  let lastServerDraftId = React.useRef(serverDraftId);
  let lastScopeKey = React.useRef(scopeKey);
  if (lastScopeKey.current !== scopeKey) {
    scopeIdentity.current = serverDraftId !== undefined ? "server:" + serverDraftId + ":" + scopeKey : "local:" + V4();
    lastServerDraftId.current = serverDraftId;
    lastScopeKey.current = scopeKey;
  } else {
    let match = lastServerDraftId.current;
    if (match !== undefined) {
      if (serverDraftId !== undefined) {
        if (match !== serverDraftId) {
          scopeIdentity.current = "server:" + serverDraftId + ":" + scopeKey;
          lastServerDraftId.current = serverDraftId;
        }
      } else {
        scopeIdentity.current = "local:" + V4();
        lastServerDraftId.current = undefined;
      }
    } else if (serverDraftId !== undefined) {
      lastServerDraftId.current = serverDraftId;
    }
  }
  return scopeIdentity.current;
}

let DraftScope = {
  makeLocalScope: makeLocalScope,
  useIdentity: useIdentity
};

function WizardUploads$Inner(props) {
  let initialFiles = props.initialFiles;
  let initialImages = props.initialImages;
  let match = React.useState(() => initialImages);
  let match$1 = React.useState(() => initialFiles);
  let onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  let imagesManager = Attachments.useAttachments(props.updateImages, Stdlib_List.fromArray(match[0]), onUnsupportedFileError);
  let filesManager = Attachments.useAttachments(props.updateFiles, Stdlib_List.fromArray(match$1[0]), onUnsupportedFileError);
  return props.render({
    imagesManager: imagesManager,
    filesManager: filesManager
  });
}

let Inner = {
  make: WizardUploads$Inner
};

function WizardUploads(props) {
  let __scopeKey = props.scopeKey;
  let scopeKey = __scopeKey !== undefined ? __scopeKey : "";
  let draftScopeIdentity = useIdentity(props.serverDraftId, scopeKey);
  return JsxRuntime.jsx(WizardUploads$Inner, {
    initialImages: props.initialImages,
    initialFiles: props.initialFiles,
    updateImages: props.updateImages,
    updateFiles: props.updateFiles,
    render: props.render
  }, draftScopeIdentity);
}

let make = WizardUploads;

exports.getAttachmentStatuses = getAttachmentStatuses;
exports.makeImageAttachment = makeImageAttachment;
exports.makeFileAttachment = makeFileAttachment;
exports.imagesReadyToSave = imagesReadyToSave;
exports.filesReadyToSave = filesReadyToSave;
exports.DraftScope = DraftScope;
exports.Inner = Inner;
exports.make = make;
/* react Not a pure module */
